import axios from 'axios'
import type ScheduleMessagePayload from '@src/types/ScheduleMessagePayload'
import {Campaign} from "@src/types/Campaign";
import ScheduleMessage from "@src/types/ScheduleMessage";

export interface GetAllScheduleMessagesResponse {
    data: ScheduleMessage[]
    campaigns: Campaign[]
    canScheduleMessage: boolean
}

class ScheduleMessagesService {
    async getAll(): Promise<GetAllScheduleMessagesResponse> {
        try {
            const {data} = await axios.get(
                '/operator/v4/schedule-messages/all',
                {
                    withCredentials: true,
                }
            )

            return {
                data: data.data ?? [],
                campaigns: data.campaigns,
                canScheduleMessage: data.canScheduleMessage ?? false
            }

        } catch (error) {
            console.error('❌ Erro ao buscar mensagens agendadas', error)

            return {
                data: [],
                campaigns: [],
                canScheduleMessage: false
            }
        }
    }

    async getByToken(token: string | number | undefined): Promise<GetAllScheduleMessagesResponse> {
        try {
            const {data} = await axios.get(
                '/operator/v4/schedule-messages/by-token',
                {
                    withCredentials: true,
                    params: {
                        costumer_token: token
                    }
                }
            )

            return {
                data: data.data ?? [],
                canScheduleMessage: data.canScheduleMessage ?? false,
                campaigns: data.campaigns
            }

        } catch (error) {
            console.error('❌ Erro ao buscar mensagens agendadas', error)
            return {
                data: [],
                canScheduleMessage: false,
                campaigns: []
            }
        }
    }

    async createOrUpdate(payload: ScheduleMessagePayload): Promise<any[]> {
        if (payload.id === -1) {
            try {
                const {data} = await axios.post(
                    '/operator/v4/schedule-messages/store',
                    {
                        session_id: payload.session_id,
                        costumer_token: payload.costumer_token,
                        message: payload.message,
                        scheduled_at: new Date(payload.scheduled_at).toISOString().slice(0, 16),
                        channel_id: payload.channel_id,
                        transferred_operator_id: payload.transferred_operator_id,
                        from_modal: true
                    }
                )

                return data.data ?? []
            } catch (error) {
                console.error('❌ Erro salvar mensagem', error)
                return []
            }
        } else {
            try {
                const {data} = await axios.post(
                    '/operator/v4/schedule-messages/update',
                    {
                        id: payload.id,
                        session_id: payload.session_id,
                        costumer_token: payload.costumer_token,
                        user_id: payload.user_id,
                        message: payload.message,
                        scheduled_at: new Date(payload.scheduled_at).toISOString().slice(0, 16),
                        channel_id: payload.channel_id,
                        transferred_operator_id: payload.transferred_operator_id,
                        from_modal: true
                    }
                )

                return data.data ?? []
            } catch (error) {
                console.error('❌ Erro atualizar mensagem', error)
                return []
            }
        }
    }

    async destroy(id: number): Promise<ScheduleMessage[]> {
        try {
            const {data} = await axios.post(
                '/operator/v4/schedule-messages/destroy',
                {
                    id: id
                }
            )

            return data.data ?? []
        } catch (error) {
            console.error('❌ Erro ao apagar mensagem agendada', error)
            return []
        }
    }
}

export default new ScheduleMessagesService()
